import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { CaretDown, Question } from '@phosphor-icons/react';

const FAQPage = () => {
  const { language } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);

  const titles = {
    fr: "Questions Fréquentes",
    en: "Frequently Asked Questions",
    it: "Domande Frequenti"
  };

  const subtitles = {
    fr: "Trouvez les réponses à toutes vos questions sur nos sorties pêche",
    en: "Find answers to all your questions about our fishing trips",
    it: "Trova le risposte a tutte le tue domande sulle nostre uscite di pesca"
  };

  const faqs = [
    {
      question: {
        fr: "Quelles sont les sorties proposées par Calvi Fishing ?",
        en: "What fishing trips does Calvi Fishing offer?",
        it: "Quali uscite propone Calvi Fishing?"
      },
      answer: {
        fr: "Nous proposons plusieurs types de sorties en mer :\n• Pêche Découverte 2H : idéale pour découvrir la pêche en famille ou entre amis.\n• Pêche au gros 4H ou 6H : pour tenter d'attraper thons, sérioles et autres grands prédateurs.\n• Pêche côtière 4H : pour cibler des espèces prestigieuses comme le pagre, le chapon ou le saint-pierre.\n• Pêche au calamar 4H : une expérience nocturne unique.\n• Sorties personnalisées : adaptées à vos envies et à votre niveau.",
        en: "We offer several types of sea trips:\n• Discovery Fishing 2H: ideal for discovering fishing with family or friends.\n• Big Game Fishing 4H or 6H: to try to catch tuna, amberjack and other large predators.\n• Coastal Fishing 4H: to target prestigious species such as red porgy, scorpionfish or John Dory.\n• Squid Fishing 4H: a unique night experience.\n• Customized trips: adapted to your wishes and level.",
        it: "Proponiamo diversi tipi di uscite in mare:\n• Pesca Scoperta 2H: ideale per scoprire la pesca in famiglia o con amici.\n• Pesca Grossa 4H o 6H: per provare a catturare tonni, ricciole e altri grandi predatori.\n• Pesca Costiera 4H: per mirare a specie prestigiose come il pagro, lo scorfano o il pesce San Pietro.\n• Pesca ai Calamari 4H: un'esperienza notturna unica.\n• Uscite personalizzate: adattate ai tuoi desideri e al tuo livello."
      }
    },
    {
      question: {
        fr: "Quel est le bateau utilisé pour les sorties ?",
        en: "What boat is used for the trips?",
        it: "Quale barca viene utilizzata per le uscite?"
      },
      answer: {
        fr: "Nos sorties se déroulent à bord du Bayliner Trophy 2503 CC, baptisé ANDILANA. C'est un bateau conçu pour la pêche sportive, équipé d'un moteur Mercury 350 CV offrant rapidité, stabilité et confort.",
        en: "Our trips take place aboard the Bayliner Trophy 2503 CC, named ANDILANA. It's a boat designed for sport fishing, equipped with a Mercury 350 HP engine offering speed, stability and comfort.",
        it: "Le nostre uscite si svolgono a bordo del Bayliner Trophy 2503 CC, chiamato ANDILANA. È una barca progettata per la pesca sportiva, equipaggiata con un motore Mercury da 350 CV che offre velocità, stabilità e comfort."
      }
    },
    {
      question: {
        fr: "Dois-je apporter mon propre matériel de pêche ?",
        en: "Do I need to bring my own fishing equipment?",
        it: "Devo portare la mia attrezzatura da pesca?"
      },
      answer: {
        fr: "Non, tout l'équipement de pêche haut de gamme est fourni, y compris les cannes, moulinets et appâts.",
        en: "No, all high-end fishing equipment is provided, including rods, reels and bait.",
        it: "No, tutta l'attrezzatura da pesca di alta gamma è fornita, comprese canne, mulinelli e esche."
      }
    },
    {
      question: {
        fr: "Faut-il une expérience préalable pour participer ?",
        en: "Do I need prior experience to participate?",
        it: "Serve esperienza precedente per partecipare?"
      },
      answer: {
        fr: "Pas du tout ! Nos sorties sont adaptées aux débutants comme aux pêcheurs expérimentés. Votre guide, Paul Salvi, sera là pour vous conseiller et vous initier aux différentes techniques.",
        en: "Not at all! Our trips are suitable for beginners as well as experienced fishermen. Your guide, Paul Salvi, will be there to advise you and introduce you to the different techniques.",
        it: "Assolutamente no! Le nostre uscite sono adatte sia ai principianti che ai pescatori esperti. La tua guida, Paul Salvi, sarà lì per consigliarti e introdurti alle diverse tecniche."
      }
    },
    {
      question: {
        fr: "Comment réserver une sortie ?",
        en: "How do I book a trip?",
        it: "Come posso prenotare un'uscita?"
      },
      answer: {
        fr: "Vous pouvez réserver directement via notre site web en sélectionnant la sortie de votre choix, la date et le créneau horaire. Le paiement se fait en ligne de manière sécurisée. Vous pouvez également nous contacter par téléphone ou sur les réseaux sociaux.",
        en: "You can book directly via our website by selecting the trip of your choice, the date and time slot. Payment is made online securely. You can also contact us by phone or on social media.",
        it: "Puoi prenotare direttamente tramite il nostro sito web selezionando l'uscita di tua scelta, la data e la fascia oraria. Il pagamento viene effettuato online in modo sicuro. Puoi anche contattarci telefonicamente o sui social media."
      }
    },
    {
      question: {
        fr: "Que faut-il prévoir pour la sortie en mer ?",
        en: "What should I bring for the sea trip?",
        it: "Cosa devo portare per l'uscita in mare?"
      },
      answer: {
        fr: "Nous vous recommandons :\n• Des vêtements adaptés (casquette, lunettes de soleil, coupe-vent)\n• De la crème solaire\n• De l'eau et des en-cas\n• Votre bonne humeur !",
        en: "We recommend:\n• Appropriate clothing (cap, sunglasses, windbreaker)\n• Sunscreen\n• Water and snacks\n• Your good mood!",
        it: "Vi consigliamo:\n• Abbigliamento adatto (cappellino, occhiali da sole, giacca a vento)\n• Crema solare\n• Acqua e snack\n• Il vostro buon umore!"
      }
    },
    {
      question: {
        fr: "Que se passe-t-il en cas de mauvais temps ?",
        en: "What happens in case of bad weather?",
        it: "Cosa succede in caso di maltempo?"
      },
      answer: {
        fr: "Si les conditions météo ne permettent pas de naviguer en toute sécurité, la sortie sera reportée à une autre date ou remboursée intégralement. Nous vous contacterons pour convenir d'une nouvelle date.",
        en: "If weather conditions do not allow safe navigation, the trip will be rescheduled or fully refunded. We will contact you to arrange a new date.",
        it: "Se le condizioni meteo non consentono di navigare in sicurezza, l'uscita sarà riprogrammata o completamente rimborsata. Vi contatteremo per concordare una nuova data."
      }
    },
    {
      question: {
        fr: "Peut-on garder les poissons pêchés ?",
        en: "Can we keep the fish we catch?",
        it: "Possiamo tenere i pesci pescati?"
      },
      answer: {
        fr: "Oui, sous réserve du respect des tailles légales et des quotas en vigueur. Nous favorisons une pêche responsable pour préserver les ressources marines.",
        en: "Yes, subject to compliance with legal sizes and quotas in force. We promote responsible fishing to preserve marine resources.",
        it: "Sì, nel rispetto delle taglie legali e delle quote in vigore. Promuoviamo una pesca responsabile per preservare le risorse marine."
      }
    },
    {
      question: {
        fr: "Y a-t-il une limite d'âge pour participer ?",
        en: "Is there an age limit to participate?",
        it: "C'è un limite di età per partecipare?"
      },
      answer: {
        fr: "Les enfants sont les bienvenus, à condition d'être accompagnés d'un adulte. Il n'y a pas de limite d'âge maximum.",
        en: "Children are welcome, provided they are accompanied by an adult. There is no maximum age limit.",
        it: "I bambini sono i benvenuti, a condizione che siano accompagnati da un adulto. Non c'è limite massimo di età."
      }
    },
    {
      question: {
        fr: "Puis-je privatiser le bateau pour un événement spécial ?",
        en: "Can I charter the boat for a special event?",
        it: "Posso privatizzare la barca per un evento speciale?"
      },
      answer: {
        fr: "Oui, nous proposons des sorties privatisées pour anniversaires, événements d'entreprise, enterrements de vie de garçon/jeune fille ou toute autre occasion spéciale. Le tarif de privatisation vous garantit le bateau entier pour votre groupe (jusqu'à 4 personnes).",
        en: "Yes, we offer private trips for birthdays, corporate events, stag/hen parties or any other special occasion. The charter rate guarantees you the entire boat for your group (up to 4 people).",
        it: "Sì, offriamo uscite private per compleanni, eventi aziendali, addii al celibato/nubilato o qualsiasi altra occasione speciale. La tariffa di privatizzazione vi garantisce l'intera barca per il vostro gruppo (fino a 4 persone)."
      }
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen pb-20 bg-[#b7ede0]" data-testid="faq-page">
      {/* Header */}
      <div className="bg-[#b7ede0] pt-28 sm:pt-36 pb-12 sm:pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 rounded-full bg-[#000000] flex items-center justify-center mx-auto mb-6">
            <Question size={32} className="text-[#b7ede0]" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-[#000000] font-['Playfair_Display'] mb-4">
            {titles[language] || titles.fr}
          </h1>
          <p className="text-[#000000]/70 text-lg max-w-2xl mx-auto">
            {subtitles[language] || subtitles.fr}
          </p>
        </div>
      </div>

      {/* FAQ List */}
      <div className="bg-[#F8FAFC]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden card-shadow"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-[#b7ede0]/10 transition-colors"
              >
                <span className="font-semibold text-[#000000] pr-4">
                  {faq.question[language] || faq.question.fr}
                </span>
                <CaretDown 
                  size={20} 
                  className={`text-[#000000] flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5 animate-fade-up">
                  <div className="pt-2 border-t border-[#b7ede0]/30">
                    <p className="text-[#4B5563] whitespace-pre-line pt-4">
                      {faq.answer[language] || faq.answer.fr}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  );
};

export default FAQPage;
